export default __webpack_public_path__ + "static/media/p2.cb91219b.PNG";